// extracted by mini-css-extract-plugin
module.exports = {"root":"ap__4__root","eventEnded":"_2zqCN__eventEnded","kpiContainer":"f-aDi__kpiContainer","tabPanel":"_2HH0e__tabPanel"};